import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/site/Layout";

export default function Models() {
  const [models, setModels] = useState([]);
  useEffect(() => { api.get("/models").then(r => setModels(r.data)); }, []);

  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-24">
        <div className="overline mb-3">The Archive · Vol. I</div>
        <h1 className="font-serif-editorial text-5xl md:text-7xl tracking-tighter mb-16 max-w-4xl">
          Models in residence.
        </h1>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6 stagger">
          {models.map((m, i) => (
            <Link
              to={`/models/${m.model_id}`}
              key={m.model_id}
              className="group block"
              data-testid={`model-card-${i}`}
            >
              <div className="aspect-[3/4] overflow-hidden bg-neutral-900 relative">
                <img src={m.profile_photo} alt={m.name}
                  className="w-full h-full object-cover thumb-locked group-hover:!filter-none group-hover:!blur-0 group-hover:!grayscale-0 transition-all duration-1000"/>
              </div>
              <div className="mt-4 flex items-baseline justify-between">
                <div>
                  <div className="font-serif-editorial text-xl tracking-tight">{m.name}</div>
                  <div className="overline mt-1">{m.tags.slice(0,2).join(" · ")}</div>
                </div>
                <div className="overline">{String(i+1).padStart(2,'0')}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
